'use strict';

/**
 * @function
 * @description Prepares data for beauty consultation update calls
 * @param {Object} form jQuery object of the beauty consultation form
 * @returns {Object} data object to the ajax calls
 */
function prepareFormData(form) {
    const data = {};

    form.find('.js-bc-boxes').each(function () {
        const inputField = $(this).find('input');
        const fieldName = inputField.attr('name');
        data[fieldName] = '';

        const selectedInputs = inputField.filter(':checked').toArray();

        if (selectedInputs.length > 0) {
            const selectedValues = selectedInputs.map(function (element) {
                return $(element).val();
            });
            data[fieldName] = selectedValues.join(',');
        }
    });

    form.find('textarea').each(function() {
        const currentField = $(this);
        data[currentField.attr('name')] = currentField.val();
    });

    const csrfToken = form.find('.csrf-token');
    data[csrfToken.attr('name')] = csrfToken.val();
    data.format = 'ajax';

    return data;
}

export default {
    prepareFormData
}
